<template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-2">
          <b-form-group id="input-group-1" label="Mapa:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="ficha.map"
              type="text"
              placeholder="Código mapa"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group id="input-group-9" label="Cor" label-for>
            <select v-model="ficha.color" class="form-control">
              <option value="red">Vermelho</option>
              <option value="green">Verde</option>
            </select>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Telefone de contato"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="ficha.contact_phone"
              type="text"
              placeholder="Telefone de contato"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Nome embarque"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="ficha.boarding_name"
              type="text"
              placeholder="Nome para embarque"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Nome comercial"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="ficha.commercial_name"
              type="text"
              placeholder="Nome comercial"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Nº de Risco"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="ficha.risk_number"
              type="text"
              placeholder="Nº de Risco"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group id="input-group-1" label="ONU" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="ficha.onu_number"
              type="text"
              placeholder="ONU"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Classe e subclasse de risco"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="ficha.risk_of_class"
              type="text"
              placeholder="Classe e subclasse de risco"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Descrição do risco"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="ficha.risk_description_of_class"
              type="text"
              placeholder="Descrição do risco"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Grupo de embalagem"
            label-for="input-2"
          >
            <select v-model="ficha.packing_group" class="form-control">
              <option value="I">I</option>
              <option value="II">II</option>
              <option value="III">III</option>
            </select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Aspecto" label-for="input-2">
            <textarea
              class="form-control"
              id="input-2"
              rows="5"
              v-model="ficha.aspect"
              type="text"
              placeholder="Aspecto"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="EPI" label-for="input-2">
            <textarea
              class="form-control"
              id="input-2"
              rows="5"
              v-model="ficha.epi"
              type="text"
              placeholder="EPI"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Fogo" label-for="input-2">
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.fire"
              type="text"
              placeholder="Fogo"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Saúde" label-for="input-2">
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.health"
              type="text"
              placeholder="Saúde"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Meio ambiente"
            label-for="input-2"
          >
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.environment"
              type="text"
              placeholder="Meio ambiente"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Vazamento"
            label-for="input-2"
          >
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.leak"
              type="text"
              placeholder="Vazamento"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Acidente fogo"
            label-for="input-2"
          >
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.fire_accident"
              type="text"
              placeholder="Acidade fogo"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Poluição" label-for="input-2">
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.pollution"
              type="text"
              placeholder="Poluição"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Envolvimento das pessoas"
            label-for="input-2"
          >
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.person_involvement"
              type="text"
              placeholder="Envolvimento das pessoas"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Informações do médico"
            label-for="input-2"
          >
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.information_doctor"
              type="text"
              placeholder="Informações do médico"
              required
            ></textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Observações"
            label-for="input-2"
          >
            <textarea
              class="form-control"
              rows="5"
              id="input-2"
              v-model="ficha.observation"
              type="text"
              placeholder="Observações"
              required
            ></textarea>
          </b-form-group>
        </div>
      </div>

      <b-button type="submit" variant="success" @click.prevent="salvarFicha"
        >Salvar</b-button
      >
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import fichaService from '@/src/services/fichaemergencia'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  components: { Loading },
  props: {
    ficha: {},
  },
  data() {
    return {
      isLoading: false,
      modal: {
        mensagems: [],
        show: false,
      },
    }
  },
  watch: {},
  mounted() {},
  methods: {
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    salvarFicha() {
      this.isLoading = true
      if (this.ficha.id != undefined) {
        fichaService
          .atualizar(this.ficha)
          .then((resposta) => {
            this.isLoading = false
            this.ficha = {}
            this.makeToast('Aviso', resposta.data.message, 'success')
          })
          .catch((erro) => {
            this.isLoading = false
            this.makeToast('Aviso', erro.data.message, 'danger')
          })
      } else {
        fichaService
          .salvar(this.ficha)
          .then((resposta) => {
            this.isLoading = false
            this.ficha = {}
            this.makeToast('Aviso', resposta.data.message, 'success')
          })
          .catch((erro) => {
            this.isLoading = false
            this.makeToast('Erro', erro.data.message, 'danger')
          })
      }
    },
    makeToast(title, msg, variant = null) {
      this.$bvToast.toast(msg, {
        toaster: 'b-toaster-top-center',
        variant: variant,
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
  },
}
</script>

<style>
</style>